export const BMS = {
  value: "BookMyShow",
};
export const PVR = {
  value: "PVR",
};

export const MG = {
  value: "MG-MOTORS",
};
